<template>
  <div class="p-4">
    <OverviewChart
      :app="app"
      :sheet="sheet"
      :transactions="transactions"
    />
  </div>
</template>

<script>
import OverviewChart from '@/app/views/transactions/charts/overview-chart.vue'

export default {
  components: {
    OverviewChart
  },
  props: ['app', 'sheet', 'transactions']
}
</script>
